import React, { useState, useEffect } from "react";
import { Loader, Message } from "semantic-ui-react";
import { filter, map, size, some } from "lodash";
import {
  HeaderPage,
  TableCategoryAdmin,
  AddEditCategoryForm,
} from "../../components/Admin";
import { ModalBasic, ModalConfirm } from "../../components/Common";
import { useCategory } from "../../hooks";

export function CategoriesAdmin() {
  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState(null);
  const [contentModal, setContentModal] = useState(null);
  const [refetch, setRefetch] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const { loading, categories, getCategories, deleteCategory } = useCategory();

  useEffect(() => {
    getCategories();
  }, [refetch]);

  // Si el local usa áreas de producción, una categoría activa sin área deja
  // sus pedidos fuera de la pantalla de cada área (solo se ven en "Todas").
  const usesAreas = some(categories, (category) => category.production_area?.trim());
  const withoutArea = usesAreas
    ? filter(
        categories,
        (category) => category.active && !category.production_area?.trim()
      )
    : [];

  const openCloseModal = () => setShowModal((prev) => !prev);
  const onRefetch = () => setRefetch((prev) => !prev);

  const addCategory = () => {
    setTitleModal("Nueva categoria");
    setContentModal(
      <AddEditCategoryForm onClose={openCloseModal} onRefetch={onRefetch} />
    );
    openCloseModal();
  };

  const updateCategory = (data) => {
    setTitleModal("Actualizar categoria");
    setContentModal(
      <AddEditCategoryForm
        onClose={openCloseModal}
        onRefetch={onRefetch}
        category={data}
      />
    );
    openCloseModal();
  };

  const onDeleteCategory = (data) => setDeleteTarget(data);

  const confirmDeleteCategory = async () => {
    await deleteCategory(deleteTarget.id);
    setDeleteTarget(null);
    onRefetch();
  };

  return (
    <>
      <HeaderPage
        title="Categorias"
        btnTitle="Nueva categoria"
        btnClick={addCategory}
      />
      {loading ? (
        <Loader active inline="centered">
          Cargando...
        </Loader>
      ) : (
        <>
          {size(withoutArea) > 0 && (
            <Message warning>
              <strong>Sin área de producción:</strong>{" "}
              {map(withoutArea, "title").join(", ")}. Sus pedidos no aparecen en
              la pantalla de Cocina de ningún área (solo en "Todas las áreas").
            </Message>
          )}
          <TableCategoryAdmin
            categories={categories}
            updateCategory={updateCategory}
            deleteCategory={onDeleteCategory}
          />
        </>
      )}

      <ModalBasic
        show={showModal}
        onClose={openCloseModal}
        title={titleModal}
        children={contentModal}
      />

      <ModalConfirm
        title="¿Eliminar categoría?"
        content={`Se eliminará "${deleteTarget?.title}" de forma permanente.`}
        show={!!deleteTarget}
        onCloseText="Cancelar"
        onClose={() => setDeleteTarget(null)}
        onConfirmText="Eliminar"
        onConfirm={confirmDeleteCategory}
      />
    </>
  );
}
